/**
 * @fileoverview Defines the `FeatureFlagDebugger` component for displaying feature flag and user information in development. It uses `useAuth` and `useStatsigClient` to show connection status and user info. This component aids in debugging feature flag configurations.
 */

import { useStatsigClient } from '@statsig/react-bindings'
import React from 'react'
import { useAuth } from '../hooks/useAuth'
import { isDev } from '../utils/env'

const STYLES: React.CSSProperties = {
  position: 'fixed',
  bottom: '36px',
  right: '10px',
  background: '#f0f0f0',
  padding: '10px',
  border: '1px solid #ccc',
  borderRadius: '5px',
  fontSize: '12px',
  maxWidth: '300px',
}

export const FeatureFlagDebugger: React.FC = () => {
  const { user } = useAuth()
  const { client } = useStatsigClient()

  if (!isDev()) {
    return null
  }

  if (!client) {
    return (
      <div style={STYLES}>
        <strong>Statsig Debug</strong>
        <div>❌ Disconnected</div>
      </div>
    )
  }

  return (
    <div style={STYLES}>
      <strong>Statsig Debug</strong>
      <div>✅ Connected</div>
      <div>{user?.email || 'Anonymous'}</div>
    </div>
  )
}
